import React, { Component } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { infoScreenAriaLabel } from '../Constants/AriaLabelText'
import { samplesMapForInfoCategories as samplesMapForInfoCategoriesFunc } from '../Constants/InfoScreenText'
import { samplesMapForInfoCategoriesMofo as samplesMapForInfoCategoriesFuncMofo } from '../Constants/InfoScreenText'
import { injectIntl, FormattedMessage } from 'react-intl'
let categoryIcons = {
  'Job Role': (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/job_role.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
  'Company/Organisation': (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/company.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
  'Company/Organization': (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/company.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
  Degree: (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/degree.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
  Concentration: (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/concentration.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
  'School/University': (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/school.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
  'Job Function': (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/job_function.svg`}
      alt=""
      width="24"
      height="30"
    />
  ),
  Industry: (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/industry.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
  Certifications: (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/certification.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
  Competitions: (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/competition.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
  Awards: (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/awards.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
  'Goal Based Keyword': (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/goals.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
  'Position of Responsibility': (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/por.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
  'Club/Society': (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/clubs.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
  'Contact Information': (
    <img
      src={`${process.env.APP_BASE_URL}dist/images/contact_info.svg`}
      alt=""
      width="28"
      height="28"
    />
  ),
}


class InfoCategories extends Component {
  constructor(props) {
    super(props)
    this.state = {
      index: 0,
      slideLength: 0,
    }

    this.showDivs = this.showDivs.bind(this)
    this.len = 0
  }

  componentDidMount() {
    this.setState((prevState) => ({ index: prevState.index }))
    this.len = 0
  }

  componentDidUpdate() {
    this.showDivs(this.state.index)
  }

  prevSample() {
    if (this.state.index > 0) {
      this.setState((prevState) => ({ index: prevState.index - 1 }))
    }
  }

  nextSample(len) {
    if (this.state.index < len - 1) {
      this.setState((prevState) => ({ index: prevState.index + 1 }))
    }
  }

  showDivs(n) {
    let i = 0
    let x = $('.mySlides')
    this.len = x.length
    let images = $('.cate-carousel-inner .item img')

    for (i = 0; i < x.length; i++) {
      $(x[i]).css('display', 'none')
    }
    $(x[this.state.index]).css('display', 'block')
  }

  categoryIconsNameList(sectionName) {
    if (sectionName === 'Headline') {
      return {
        left_col: [
          "Job Role",
          "Club/Society",
          "Industry",
          "Degree",
          "Concentration",
          "Job Function",
        ],
        right_col: [
          "School/University",
          "Certifications",
          "Goal Based Keyword",
          "Company/Organisation",
          "Position of Responsibility",
        ],
      };
    }
    if (sectionName === 'Summary') {
      return {
        left_col: [
          "Awards",
          "Club/Society",
          "Job Role",
          "Competitions",
          "Degree",
          "Concentration",
          "Industry",
        ],
        right_col: [
          "Job Function",
          "Certifications",
          "School/University",
          "Goal Based Keyword",
          "Contact Information",
          "Company/Organisation",
          "Position of Responsibility",
        ],
      };
    }
    if (sectionName === 'Experience') {
      return {
        left_col: [
          "Awards",
          "Club/Society",
          "Industry",
          "Competitions",
          "Degree",
          "Concentration",
          "Job Role",
        ],
        right_col: [
          "Job Function",
          "Certifications",
          "Goal Based Keyword",
          "School/University",
          "Company/Organisation",
          "Position of Responsibility",
        ],
      };
    }
    if (sectionName === 'Education') {
      return {
        left_col: [
          "Awards",
          "Club/Society",
          "Competitions",
          "Degree",
        ],
        right_col: [
          "Concentration",
          "School/University",
          "Certifications",
          "Position of Responsibility",
        ],
      };
    }
  }

  render() {
    const { currentSection, isUKEnable, user, community, intl, pdfLanguage } = this.props
    let leftStaticCategories = []
    let samplesMapForInfoCategories = samplesMapForInfoCategoriesFunc(
      isUKEnable, intl
    )
    if (community === 'mofo') {
      samplesMapForInfoCategories = samplesMapForInfoCategoriesFuncMofo(
        isUKEnable, intl
      )
    }
    this.len = samplesMapForInfoCategories[currentSection]['slides'].length

    for (
      let i = 0;
      i <
      samplesMapForInfoCategories[currentSection]['static_categories'][
        'left_col'
      ].length;
      i++
    ) {
      leftStaticCategories.push(
        <li className='category-list-item'>
          {
            categoryIcons[
              this.categoryIconsNameList(currentSection)['left_col'][i]
            ]
          }{' '}
          {
            samplesMapForInfoCategories[currentSection]['static_categories'][
              'left_col'
            ][i]
          }{' '}
        </li>
      )
    }

    let rightStaticCategories = []

    for (
      let i = 0;
      i <
      samplesMapForInfoCategories[currentSection]['static_categories'][
        'right_col'
      ].length;
      i++
    ) {
      rightStaticCategories.push(
        <li 
          className='category-list-item'
          key={i}>
          {
            categoryIcons[
              this.categoryIconsNameList(currentSection)['right_col'][i]
            ]
          }{' '}
          {
            samplesMapForInfoCategories[currentSection]['static_categories'][
              'right_col'
            ][i]
          }
        </li>
      )
    }

    let slideClassName = classNames('row', 'mySlides', {
      [`${currentSection}-slides-height`]: true,
    })
    let slides = []

    let isReverseSlide = false
    let summarySlideCount = 0
    if (
      currentSection === 'Summary' &&
      community === 'ivey' &&
      (user.benchmark === 'hba_test' || user.benchmark === 'msc_test')
    ) {
      isReverseSlide = true
      summarySlideCount =
        samplesMapForInfoCategories[currentSection]['slides'].length
    }

    for (
      let i = 0;
      i < samplesMapForInfoCategories[currentSection]['slides'].length;
      i++
    ) {
      let categories = []

      for (
        let j = 0;
        j <
        samplesMapForInfoCategories[currentSection]['slides'][i]['categories']
          .length;
        j++
      ) {
        categories.push(
          <div className="col-sm-6 cate-first-impression">
            <ul>
              <li key={j}>
                <span className="green-icon-cr cr-icon-width text-color-green">
                  {' '}
                  {
                    samplesMapForInfoCategories[currentSection]['slides'][i][
                      'categories'
                    ][j]['albhabet']
                  }{' '}
                </span>{' '}
                {
                  samplesMapForInfoCategories[currentSection]['slides'][i][
                    'categories'
                  ][j]['name']
                }{' '}
              </li>
            </ul>
          </div>
        )
        if (j % 2 != 0) {
          categories.push(<div className="clearfix" />)
        }
      }

      slides.push(
        <div className={slideClassName}>
          <div className="slide-info-sub-heading">
            <FormattedMessage
              id="infoCategories.slideSubHeading"
              defaultMessage="Illustrations of how Information Categories improve the first impression"
            />
          </div>
          {
            isReverseSlide
            ? samplesMapForInfoCategories[currentSection]['slides'][summarySlideCount - i - 1]['text'] 
            : samplesMapForInfoCategories[currentSection]['slides'][i]['text']
          }
          <div className="row as-info-modal-category">{categories}</div>
        </div>
      )
    }

    return (
      <div>
        <div className="as-info-modal-wrapper">
          <div className="as-info-modal-close">
            <a
              href="javascript:void(0);"
              aria-label={infoScreenAriaLabel(intl)['close']}
              onClick={() => this.props.hideModal()}
              className="icon-cross as-profile-edit-close-btn modal-close-button"
            />
          </div>
          <div className="as-info-modal-heading">
            <FormattedMessage
              id="infoCategories.heading"
              defaultMessage="Information Categories"
            />
          </div>
          <div className="as-info-modal-subheading">
            <FormattedMessage
              id="infoCategories.subHeading"
              defaultMessage="What are Information Categories?"
            />
          </div>
          <div className="as-info-modal-desc">
            {samplesMapForInfoCategories[currentSection]['sub_heading']}
          </div>
          <div className="row as-info-modal-content as-info-modal-content-categories">
            <div className="col-sm-7">
              {slides}
              { ['us', 'uk', 'english'].includes(pdfLanguage) && (
                <div className="as-info-modal-slide-btn-div">
                  <div className="as-info-modal-slide-left">
                    {this.state.index != 0 ? (
                      <a
                        className="sample-prev"
                        href="javascript:void(0);"
                        aria-label={
                          infoScreenAriaLabel(intl)['category']['previous']
                        }
                        onClick={() => this.prevSample()}>
                        {' '}
                        <span className="arrow arrow-left"/>{' '}
                      </a>
                    ) : (
                      <a
                        className="sample-prev-disabled"
                        href="javascript:void(0);"
                        aria-label={
                          infoScreenAriaLabel(intl)['category']['previous'] + ' disabled'
                        }
                      >
                        <span className="arrow arrow-left"/>
                      </a>
                    )}
                  </div>
                  <div className="as-info-modal-slide-status">
                    <div className="text-center">
                      <div className="categories-bt-number">
                        <span style={{ fontWeight: '700', fontSize: '14px' }}>{this.state.index + 1}</span>/{this.len}
                      </div>
                    </div>
                  </div>
                  <div className="as-info-modal-slide-left">
                    {this.state.index != this.len - 1 ? (
                      <a
                        className="sample-next"
                        href="javascript:void(0);"
                        aria-label={infoScreenAriaLabel(intl)['category']['next']}
                        onClick={() => this.nextSample(this.len)}>
                        {' '}
                        <span className="arrow arrow-right" />{' '}
                      </a>
                    ) : (
                      <a
                        className="sample-next-disabled"
                        href="javascript:void(0);"
                        aria-label={infoScreenAriaLabel(intl)['category']['next']+' disabled'}>
                        {' '}
                        <span className="arrow arrow-right" />{' '}
                      </a>
                    )}
                  </div>
                  <div className="clearfix" />
                </div>
              )}
            </div>
            <div className="col-sm-5">
              <div className="smp-bullets as-info-modal-smp-bullets">
                <div className="as-info-modal-smp-heading">
                  <FormattedMessage
                    id="infoCategories.listHeading"
                    defaultMessage="List of Information Categories"
                  />
                </div>
                <div className="row ">
                  <div className="col-sm-6 padding-rl-0">
                    <ul>{leftStaticCategories}</ul>
                  </div>
                  <div className="col-sm-6 padding-rl-0">
                    <ul>{rightStaticCategories}</ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    pdfLanguage: state.aspireFeedbackData.pdf_language,
  }
}

export default connect(mapStateToProps, {  })(
  injectIntl(InfoCategories)
)